module.exports = __webpack_public_path__ + "img/login_body_bg.d18861ec.png";